import {
  Button,
  DatePickerFieldController,
  SelectFieldController,
  Stack,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type BranchOption = {
  value: string;
  label: string;
};

type Props = {
  /** 事業所選択肢 */
  branchOptions: BranchOption[];
  /** 作成API実行中フラグ */
  isMutating: boolean;
  /** フォーム送信ハンドラ */
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
  /** キャンセルハンドラ */
  onCancel: () => void;
};

/**
 * 利用者新規作成フォームの Presentation コンポーネント
 */
export const CreateUserFormPresentation: React.FC<Props> = ({
  branchOptions,
  isMutating,
  onSubmit,
  onCancel,
}) => (
  <form onSubmit={onSubmit}>
    <Stack direction='column' gap={24}>
      <h2 className={styles.formTitle}>利用者の新規追加</h2>
      <Stack direction='column' gap={16} width='368px'>
        <TextInputFieldController
          name='fullName'
          fieldWrapperProps={{ labelText: '氏名', labelType: 'required' }}
          textInput={{ placeholder: '福利 太郎' }}
        />
        <TextInputFieldController
          name='email'
          fieldWrapperProps={{ labelText: 'メールアドレス', labelType: 'required' }}
          textInput={{ placeholder: 'fukuri@example.com', type: 'email' }}
        />
        {branchOptions.length > 0 && (
          <SelectFieldController
            name='branchId'
            fieldWrapperProps={{ labelText: '事業所' }}
            select={{
              placeholder: '事業所を選択',
              options: branchOptions,
              clearable: true,
            }}
          />
        )}
        <DatePickerFieldController
          name='billableFrom'
          fieldWrapperProps={{ labelText: '利用開始日', labelType: 'required' }}
        />
      </Stack>
      <Stack direction='row' gap={8}>
        <Button variant='outline' type='button' onClick={onCancel} disabled={isMutating}>
          キャンセル
        </Button>
        <Button type='submit' disabled={isMutating}>
          追加
        </Button>
      </Stack>
    </Stack>
  </form>
);
